import { render } from "./disclaimer.vue?vue&type=template&id=b54f69f6&scoped=true"
import script from "./disclaimer.vue?vue&type=script&lang=js"
export * from "./disclaimer.vue?vue&type=script&lang=js"

import "./disclaimer.vue?vue&type=style&index=0&id=b54f69f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b54f69f6"

export default script